import request from '@/sheep/request';

// 分类
export interface WishConfig {
	code: string
	isEnableLimit : boolean
	limitNumber : number
	isEnableFly : boolean
	enableFlyModel ?: number
	limitFlyNumber ?: number
}


// 查询分类精简列表
export const getWishConfig = (code: string) => {
	return request({
		url: '/wish/config/get',
		method: 'GET',
		params: { code }
	});
}

export const getBaseConfig = () => {
	return request({
		url: '/wish/config/base',
		method: 'GET',
	});
}
